import { render, staticRenderFns } from "./listNews.vue?vue&type=template&id=ce9d7926&scoped=true"
import script from "./listNews.vue?vue&type=script&lang=js"
export * from "./listNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9d7926",
  null
  
)

export default component.exports